import store from "../../store"
import Errors from "../../Errors"
import ProductRating from "../ProductRating.vue"
import ProductCardMixin from "../../mixins/ProductCardMixin"
import RelatedProducts from "./show/RelatedProducts.vue"
import QD from "../QD.vue"
import { currencyFormat } from "../../functions"
import { Edit2Icon } from "vue-feather-icons"

export default {
  components: { ProductRating, RelatedProducts, QD, Edit2Icon },

  mixins: [
    ProductCardMixin
  ],

  props: ["product", "reviewCount", "avgRating", "isAdmin", "payment_methods"],

  data() {
    return {
      fields: [
        { key: "qty", label: "Quantity", type: "Range" }
      ],
      activeTab: "description",
      currentReviewPage: 1,
      fetchingReviews: false,
      reviews: {},
      addingNewReview: false,
      reviewForm: {},
      selectedVariantId: null,
      cartItemForm: {
        product_variant_id: undefined,
        product_variant_serial_number: undefined,
        product_id: this.product.id,
        qty: 1,
        options: {}
      },
      errors: new Errors(),
      quantityDiscounts: this.product.quantity_discount,
      apiLoading: false,
      qty: 1,
      currencyFormat,
      showPop: false,
      main_image: this.product.base_image,
      selectedVariantSerialNumber: null
    }
  },

  watch: {
    qty: function(val, oldVal) {
      if (val !== oldVal) {
        this.main_image = this.getImage()
      }
    },
    main_image: function(val, oldVal) {
      $(".base-image-slide").trigger("zoom.destroy")
      $(".base-image-slide").zoom({
        url: val,
        magnify: 1.2,
        touch: false
      })
    },
    selectedVariantId: function(val, oldVal) {
      if (val) {
        this.cartItemForm.product_variant_id = val.id
        this.cartItemForm.product_variant_serial_number = val.product_variant_serial
        this.cartItemForm.options = { variant_id: val.id }

      } else {
        this.cartItemForm.product_variant_id = undefined
        this.cartItemForm.product_variant_serial_number = undefined
        this.cartItemForm.options = {}
      }

      this.main_image = this.getImage()
    }
  },
  computed: {
    isVariantNotSelected() {
      return this.product.is_variant_enabled && !this.selectedVariantId
    },
    formattedVariants() {
      return this.product.product_variants.map((variant) => ({
        ...variant,
        label: `${variant.product_variant_serial} ($${variant.price})`
      }))
    },
    maxSellingQty() {
      let maxSellingQty = this.product.max_selling_qty

      // Check for the selected product variant listing price.
      if (this.cartItemForm.product_variant_id)
        this.product.product_variants.find((variant) => {
          if (variant.id === this.cartItemForm.product_variant_id) {
            maxSellingQty = variant.qty
          }
        })

      return maxSellingQty
    },
    price() {
      return "$" + currencyFormat(this.product.formatted_price)
    },
    selling_price() {
      let displayedPrice = this.product.selling_price.formatted

      // Check for the selected product variant listing price.
      if (this.cartItemForm.product_variant_id)
        this.product.product_variants.find((variant) => {
          if (variant.id === this.cartItemForm.product_variant_id) {
            displayedPrice = variant.price
          }
        })

      return "$" + currencyFormat(displayedPrice)
    },
    totalReviews() {
      if (!this.reviews.total) {
        return this.reviewCount
      }

      return this.reviews.total
    },

    ratingPercent() {
      return (this.avgRating / 5) * 100
    },

    emptyReviews() {
      return this.totalReviews === 0
    },

    totalReviewPage() {
      return Math.ceil(this.reviews.total / 4)
    },

    giftProduct() {
      return store.state.cart.gift_products.find(item => item.id == this.product.id) != undefined
    }
  },
  created() {
    this.fetchReviews()
  },
  mounted() {
    this.payment_methods.forEach((paymentMethod) => {
      this.fields.push(
        {
          key: paymentMethod.vendors,
          label: paymentMethod.vendors,
          discount_percentage: paymentMethod.discount_percentage
        }
      )
    })
    $(this.$refs.upSellProducts).slick({
      rows: 0,
      dots: false,
      arrows: true,
      infinite: true,
      slidesToShow: 1,
      slidesToScroll: 1,
      rtl: window.Trillion.rtl
    })
  },
  methods: {
    getImage() {
      let productVariantItem = this.product.product_variants.find((variant) => {
        if (variant.id === this.cartItemForm.product_variant_id) {
          return variant
        }
      })

      if (productVariantItem && productVariantItem.base_image) {
        return productVariantItem.base_image
      }

      if (this.cartItemForm.qty == 1 || !this.product.qd_enabled)
        return this.product.base_image

      else (this.cartItemForm.qty > 1 || this.product.qd_enabled)
      {
        let level = this.product.quantity_discount_with_min_max.find((item) => {
          return this.cartItemForm.qty >= item.min_val && (this.cartItemForm.qty <= item.max_val || item.max_val == null)
        })

        if (level && level.media[0])
          return level.media[0].original_url

        return this.product.base_image
      }
    },
    getSB(qty) {
      // this.apiLoading = true
      // $.ajax({
      //     method: "GET",
      //     url: "/products/quantity/check_selling_quantity?product_id=" + this.product.id,
      // })
      //     .then(res => {
      //         this.maxSellingQty = res.data.max_selling_qty
      this.checkMaxQty(qty)
      // })
      // .always(() => {
      //     this.apiLoading = false
      return this.maxSellingQty
      // });
    },
    updateQuantity(qty) {
      this.qty = qty
      this.cartItemForm.qty = qty
      if (qty != "" && qty != 0)
        this.getSB()
    },
    debounce(callback, delay) {
      clearTimeout(this.debounceTimer)
      this.debounceTimer = setTimeout(callback, delay)
    },
    checkMaxQty() {
      this.showPop = false
      if (this.qty < 1 || this.exceedsMaxStock(this.qty)) {
        this.cartItemForm.qty = this.maxSellingQty
        this.showPop = true
        setTimeout(() => {
          this.showPop = false
        }, 3000)
        return
      }

      if (isNaN(this.qty)) {
        this.qty = 1
      }

      this.cartItemForm.qty = this.qty
    },

    exceedsMaxStock(qty) {
      return this.maxSellingQty < qty
    },

    changeReviewPage(page) {
      this.currentReviewPage = page

      this.fetchReviews()
    },

    updatePrice() {
      this.$nextTick(() => {
        $.ajax({
          method: "POST",
          url: route("products.price.show", { id: this.product.id }),
          data: { options: this.cartItemForm.options }
        }).then((price) => {
          this.price = price
        }).catch((xhr) => {
          this.$errorNotify(xhr.responseJSON.message)
        })
      })
    },

    updateSelectTypeOptionValue(optionId, e) {
      this.$set(this.cartItemForm.options, optionId, $(e.target).val())

      this.errors.clear(`options.${optionId}`)
    },

    updateCheckboxTypeOptionValue(optionId, e) {
      let values = $(e.target)
        .parents(".variant-check")
        .find("input[type=\"checkbox\"]:checked")
        .map((_, el) => {
          return el.value
        })

      this.$set(this.cartItemForm.options, optionId, values.get())
    },

    customRadioTypeOptionValueIsActive(optionId, valueId) {
      if (!this.cartItemForm.options.hasOwnProperty(optionId)) {
        return false
      }

      return this.cartItemForm.options[optionId] === valueId
    },

    syncCustomRadioTypeOptionValue(optionId, valueId) {
      if (this.customRadioTypeOptionValueIsActive(optionId, valueId)) {
        this.$delete(this.cartItemForm.options, optionId)
      } else {
        this.$set(this.cartItemForm.options, optionId, valueId)

        this.errors.clear(`options.${optionId}`)
      }

      this.updatePrice()
    },

    customCheckboxTypeOptionValueIsActive(optionId, valueId) {
      if (!this.cartItemForm.options.hasOwnProperty(optionId)) {
        this.$set(this.cartItemForm.options, optionId, [])

        return false
      }

      return this.cartItemForm.options[optionId].includes(valueId)
    },

    syncCustomCheckboxTypeOptionValue(optionId, valueId) {
      if (this.customCheckboxTypeOptionValueIsActive(optionId, valueId)) {
        this.cartItemForm.options[optionId].splice(
          this.cartItemForm.options[optionId].indexOf(valueId),
          1
        )
      } else {
        this.cartItemForm.options[optionId].push(valueId)

        this.errors.clear(`options.${optionId}`)
      }

      this.updatePrice()
    },

    fetchReviews() {
      this.fetchingReviews = true

      $.ajax({
        method: "GET",
        url: route("products.reviews.index", {
          productId: this.product.id,
          page: this.currentReviewPage
        })
      }).then((reviews) => {
        this.reviews = reviews
      }).catch((xhr) => {
        this.$errorNotify(xhr.responseJSON.message)
      }).always(() => {
        this.fetchingReviews = false
      })
    },

    addNewReview() {
      this.addingNewReview = true

      $.ajax({
        method: "POST",
        url: route("products.reviews.store", { productId: this.product.id }),
        data: this.reviewForm
      }).then((review) => {
        this.reviewForm = {}
        this.reviews.total++
        this.reviews.data.unshift(review)

        $(".captcha-input").prev("img").trigger("click")
      }).catch((xhr) => {
        if (xhr.status === 422) {
          this.errors.record(xhr.responseJSON.errors)
        } else {
          this.$errorNotify(xhr.responseJSON.message)
        }
      }).always(() => {
        this.addingNewReview = false
      })
    },
    checkCaptcha() {
      if (this.errors.has("captcha")) {
        this.refreshCaptcha()
      }
    },
    refreshCaptcha() {
      // Assuming the captcha image is a child of the form-group and is an image element
      var captchaImage = document.querySelector(".form-group img")
      if (captchaImage) {
        captchaImage.src = captchaImage.src.split("?")[0] + "?" + new Date().getTime()
      }
    },
    addToCartData(data) {
      dataLayer.push({ ecommerce: null })  // Clear the previous ecommerce object.
      dataLayer.push({
        event: "add_to_cart",
        ecommerce: {
          items: [{
            item_name: data["name"], // Name or ID is required.
            item_id: data["id"],
            price: data["price"],
            item_brand: data["brand"]?.["name"] || "",
            item_category: data["categories0"] || "",
            item_category2: data["categories1"] || "",
            item_category3: data["categories2"] || "",
            item_category4: data["categories3"] || "",
            item_variant: "",
            item_list_name: "",  // If associated with a list selection.
            item_list_id: "",  // If associated with a list selection.
            index: 0,  // If associated with a list selection.
            quantity: data["quantity"],
            variant_serial_number: data["productVariantSerialNumber"],
            variant_id: data["productVariantId"]
          }]
        }
      })
    },
    addToCart() {
      this.addingToCart = true
      this.addToCartData({
        name: this.product.name,
        id: this.product.id,
        price: this.product.price.amount,
        quantity: this.product.qty_in_stock,
        categories0: this.product.categories[0] ? this.product.categories[0].name : "",
        categories1: this.product.categories[1] ? this.product.categories[1].name : "",
        categories2: this.product.categories[2] ? this.product.categories[2].name : "",
        categories3: this.product.categories[3] ? this.product.categories[3].name : "",
        productVariantId: this.selectedVariantId,
        productVariantSerialNumber: this.selectedVariantSerialNumber
      })

      $.ajax({
        method: "POST",
        url: route("cart.items.store", this.cartItemForm)
      })
        .then((cart) => {
          store.updateCart(cart)
          this.$successNotify("Product has been added to your cart")
        })
        .catch((xhr) => {
          if (xhr.status === 422) {
            this.errors.record(xhr.responseJSON.errors)
          } else {
            this.$errorNotify(xhr.responseJSON.message)
          }
        })
        .always(() => {
          this.addingToCart = false
        })
    }
  }
}
